import { makeStyles } from '@material-ui/core/styles';
import AccountBalanceIcon from '@material-ui/icons/AccountBalance';
import AssignmentTurnedInIcon from '@material-ui/icons/AssignmentTurnedIn';
import HourglassEmptyIcon from '@material-ui/icons/HourglassEmpty';
import MarkunreadMailboxIcon from '@material-ui/icons/MarkunreadMailbox';
import MonetizationOnIcon from '@material-ui/icons/MonetizationOn';
import MoveToInboxIcon from '@material-ui/icons/MoveToInbox';
import PauseCircleFilledOutlinedIcon from '@material-ui/icons/PauseCircleFilledOutlined';
import PlaylistAddCheckIcon from '@material-ui/icons/PlaylistAddCheck';
import RadioButtonUncheckedIcon from '@material-ui/icons/RadioButtonUnchecked';
import RemoveCircleIcon from '@material-ui/icons/RemoveCircle';
import ReportProblemIcon from '@material-ui/icons/ReportProblem';
import ThumbDownIcon from '@material-ui/icons/ThumbDown';
import ThumbUpAltIcon from '@material-ui/icons/ThumbUpAlt';
import ThumbUpAltOutlinedIcon from '@material-ui/icons/ThumbUpAltOutlined';
import { colors } from '../../constants/Colors';
import { ProcessStatus } from '../../constants/Constants';
import { DxTheme } from '../../types';

const useStyles = makeStyles(
  (theme: DxTheme) => ({
    statusIcon: {
      fontSize: 'medium',
      marginRight: 3,
      verticalAlign: 'middle',
      strokeWidth: 2,
    },
  }),
  { name: 'ProcessStatusIcon' }
);

export const ProcessStatusIcon = (props) => {
  const classes = useStyles();

  switch (props.status) {
    case ProcessStatus.NEW:
    case ProcessStatus.RECEIVED_BY_DX:
    case ProcessStatus.NORMALIZED:
    case ProcessStatus.ACCOUNT_CHECKED:
    case ProcessStatus.ENRICHED:
    case ProcessStatus.VALIDATED:
    case ProcessStatus.LOCALLY_DELIVERED:
    case ProcessStatus.PAID_BY_RECIPIENT:
    case ProcessStatus.PENDING_SCHEDULED_DELIVERY:
    case ProcessStatus.DELIVERED:
    case ProcessStatus.NOTIFIED:
    case ProcessStatus.ACCEPTED_BY_CUSTOMER:
    case ProcessStatus.RECEIVED_BY_CUSTOMER:
    case ProcessStatus.SENT:
    case ProcessStatus.RECEIVED_BY_RECIPIENT:
    case ProcessStatus.ACCEPTED_BY_RECIPIENT:
    case ProcessStatus.RECEIVED_BY_SUPPLIER:
    case ProcessStatus.RECEIVED_BY_BSP:
    case ProcessStatus.RECEIVED_AND_VALIDATED_BY_BSP:
    case ProcessStatus.SUCCESSFUL_MATCHED:
    case ProcessStatus.PARTIAL_MATCHED:
      return (
        <RadioButtonUncheckedIcon
          style={{
            color: colors.functionalGreen,
            stroke: colors.functionalGreen,
          }}
          className={classes.statusIcon}
        />
      );

    case ProcessStatus.DELIVERED_FROM_FORMAT_ERROR:
    case ProcessStatus.FORMAT_ERROR:
    case ProcessStatus.DELIVERED_FROM_CONTENT_ERROR:
    case ProcessStatus.CONTENT_ERROR:
    case ProcessStatus.REJECTED_BY_CUSTOMER:
    case ProcessStatus.REJECTED_BY_RECIPIENT:
    case ProcessStatus.REJECTED_BY_SUPPLIER:
    case ProcessStatus.REJECTED_BY_BSP:
    case ProcessStatus.INVALID_MATCHING:
      return (
        <RadioButtonUncheckedIcon
          style={{
            color: colors.red[50],
            stroke: colors.red[50],
          }}
          className={classes.statusIcon}
        />
      );

    case ProcessStatus.DRAFT:
    case ProcessStatus.PENDING_TO_CUSTOMER:
    case ProcessStatus.PENDING_RECADV:
    case ProcessStatus.WAITING_FOR_RECIPIENT:
    case ProcessStatus.PENDING_ENRICHMENTS:
    case ProcessStatus.PENDING_CORRECTION:
    case ProcessStatus.MATCHING_IN_PROGRESS:
    case ProcessStatus.ALLOCATION_IN_PROGRESS:
    case ProcessStatus.PARTIALLY_PAID_BY_RECIPIENT:
    case ProcessStatus.UNDER_QUERY:
    case ProcessStatus.CONDITIONALLY_ACCEPTED:
    case ProcessStatus.IN_PROCESS:
      return (
        <HourglassEmptyIcon
          style={{
            color: colors.functionalOrange,
            stroke: colors.functionalOrange,
          }}
          className={classes.statusIcon}
        />
      );

    case ProcessStatus.SUSPENDED:
    case ProcessStatus.NO_CREDIT:
    case ProcessStatus.MATCHING_ERROR:
      return (
        <RadioButtonUncheckedIcon
          style={{
            color: colors.red[100],
            stroke: colors.red[100],
          }}
          className={classes.statusIcon}
        />
      );

    case ProcessStatus.PDP_ENCAISSEE:
      return (
        <MonetizationOnIcon
          style={{
            color: colors.functionalGreen,
          }}
          className={classes.statusIcon}
        />
      );

    case ProcessStatus.PDP_DEPOSEE:
      return (
        <MoveToInboxIcon
          style={{
            color: colors.black65,
          }}
          className={classes.statusIcon}
        />
      );

    case ProcessStatus.PDP_REFUSEE:
      return (
        <ThumbDownIcon
          style={{
            color: colors.red[100],
          }}
          className={classes.statusIcon}
        />
      );

    case ProcessStatus.PDP_REJETEE:
      return (
        <RemoveCircleIcon
          style={{
            color: colors.red[100],
          }}
          className={classes.statusIcon}
        />
      );

    // TBD Use the default one meantime
    // case ProcessStatus.PDP_EMISE_PAR_LA_PLATEFORME:
    // case ProcessStatus.PDP_RECU_PAR_LA_PLATEFORME:

    case ProcessStatus.PDP_MISE_A_DISPOSITION:
      return (
        <MarkunreadMailboxIcon
          style={{
            color: colors.black65,
          }}
          className={classes.statusIcon}
        />
      );

    case ProcessStatus.PDP_PRISE_EN_CHARGE:
      return (
        <AssignmentTurnedInIcon
          style={{
            color: colors.black65,
          }}
          className={classes.statusIcon}
        />
      );

    case ProcessStatus.PDP_APPROUVEE:
      return (
        <ThumbUpAltIcon
          style={{
            color: colors.functionalGreen,
          }}
          className={classes.statusIcon}
        />
      );

    case ProcessStatus.PDP_APPROUVEE_PARTIELLEMENT:
      return (
        <ThumbUpAltOutlinedIcon
          style={{
            color: colors.functionalOrange,
          }}
          className={classes.statusIcon}
        />
      );

    case ProcessStatus.PDP_EN_LITIGE:
      return (
        <ReportProblemIcon
          style={{
            color: colors.red[100],
          }}
          className={classes.statusIcon}
        />
      );

    case ProcessStatus.PDP_SUSPENDUE:
      return (
        <PauseCircleFilledOutlinedIcon
          style={{
            color: colors.functionalOrange,
          }}
          className={classes.statusIcon}
        />
      );

    case ProcessStatus.PDP_PAIEMENT_TRANSMIS:
      return (
        <AccountBalanceIcon
          style={{
            color: colors.functionalGreen,
          }}
          className={classes.statusIcon}
        />
      );

    case ProcessStatus.PDP_COMPLETEE:
      return (
        <PlaylistAddCheckIcon
          style={{
            color: colors.functionalGreen,
          }}
          className={classes.statusIcon}
        />
      );

    default:
      return (
        <RadioButtonUncheckedIcon
          style={{ stroke: colors.black05 }}
          className={classes.statusIcon}
        />
      );
  }
};
